import React, { useState, useEffect } from 'react';
import { Table, Button, message, Modal, Tooltip, Input } from 'antd';
import { 
    CopyOutlined,
    EditOutlined,
    DeleteOutlined,
    ExclamationCircleOutlined,
    RetweetOutlined,
    EyeOutlined
} from '@ant-design/icons';
import { 
    collection, 
    onSnapshot, 
    updateDoc, doc,
} from "firebase/firestore";
import { firestore } from '../../services/firebase';
import { useHistory } from 'react-router-dom';
import ModalInfo from './ModalInfo';
import { formatDate } from '../../utilities';


const ListaVideos = () => {

    const history = useHistory();
    const { Search } = Input;
    const { confirm } = Modal;
    const [ videos, setVideos ] = useState([]);
    const [ loading, setLoading ] = useState(true);
    const [ modalData, setModalData ] = useState([]);
    const [ isModalVisible, setIsModalVisible ] = useState(false);
    const [ filteredResults, setFilteredResults ] = useState([]);
    const [ searchInput, setSearchInput ] = useState('');


    useEffect( () => {
        let mounted = true;
        if( mounted ) {
            onSnapshot(collection(firestore, "videos"), (querySnapshot) => {
                const docs = [];
                querySnapshot.forEach( (doc) => {
                    docs.push( { ...doc.data(), id:doc.id } );
                });
                setVideos(docs);
                setLoading(false);
            });
        }
        return () => { mounted = false; }
    }, [] );

    const copyToClipBoard = ( url ) => {
        navigator.clipboard.writeText( url );
        message.success('URL Copiada!');
    };

    const onSearch = (searchValue) => {
        setSearchInput(searchValue)
        if (searchValue !== '') {
            const filteredData = videos.filter((item) => {
                return Object.values(item).join('').toLowerCase().includes(searchValue.toLowerCase());
            })
            setFilteredResults(filteredData)
        }
        else{
            setFilteredResults(videos)
        }
    };

    const showDeleteConfirm = async (i) =>  {
        let txt = i.estatus === 1 ? 'Eliminar' : 'Restaurar';
        confirm(  {
            title: `¿Estás seguro de ${txt} el video ${i.nombre} ?`,
            icon: <ExclamationCircleOutlined />,
            okText: `Si, ${txt}`,
            okType: i.estatus === 1 ? 'danger' : 'primary',
            cancelText: 'Cancelar',
            onOk: async () => {
                try {
                    await updateDoc( doc(firestore, "videos", i.id), {
                        ...i,
                        estatus: i.estatus === 0 ? 1 : 0,
                    });
                    message.success(i.estatus === 1 ? 'Video eliminado' : 'Video restaurado');
                } catch (error) {
                    console.log('Error al eliminar: '+ error);
                    message.error('Error al eliminar');
                }
            },
            onCancel() {
                // console.log('Cancel');
            },
        });
    };

    const showModal = (item) => {
        setModalData(item)
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        setModalData([]);
    };

    const defaultText = prop => prop || <span style={{ color: '#c7c3c3' }}>---</span>;

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            align: 'center',
        },
        {
            title: 'Nombre',
            dataIndex: 'nombre',
            key: 'nombre',
            render: defaultText,
        },
        {
            title: 'Autor',
            dataIndex: 'autor',
            key: 'autor',
            render: defaultText,
        },
        {
            title: 'Horario',
            dataIndex: 'horario',
            key: 'horario',
            render: (index, item) => ( formatDate(item.horario.toDate()) ),
        },
        {
            title: '',
            dataIndex: 'opciones',
            key: 'opciones',
            align: 'center',
            width: 200,
            render: ( index, item ) => (
              <div style={{ justifyContent: 'space-around', display: 'flex' }}>
                  <Tooltip title='Copiar URL de youtube'>
                      <Button
                        type="dashed"
                        shape="circle"
                        icon={ <CopyOutlined /> }
                        onClick={ () => copyToClipBoard(item.url) }
                      />
                  </Tooltip>
                  <Tooltip title='Detalles de Video'>
                      <Button
                        type="dashed"
                        shape="circle"
                        icon={ <EyeOutlined /> }
                        onClick={ () => showModal(item) }
                      />
                  </Tooltip>
                  <Tooltip title='Editar'>
                      <Button
                        style={{ backgroundColor: '#ff9800', borderColor: '#ff9800' }}
                        type="primary"
                        shape="circle"
                        icon={ <EditOutlined /> }
                        onClick={ () => history.push(`/admin/editar?id=${item.id}`)}
                      />
                  </Tooltip>
                  <Tooltip title={ item.estatus === 1 ? 'Eliminar' : 'Restaurar' }>
                      <Button
                        type={ item.estatus === 1 ? 'danger' : 'primary' }
                        shape="circle"
                        icon={ item.estatus === 1 ? <DeleteOutlined /> : <RetweetOutlined /> }
                        onClick={ () => showDeleteConfirm(item) }
                      />
                  </Tooltip>
              </div>
            )
        },
    ];

    return (
        <>
            <ModalInfo 
                setModalData={setModalData} 
                modalData={modalData}
                isModalVisible={isModalVisible}
                handleCancel={handleCancel}
            />
            <Search
                size="large"
                placeholder="Buscar" 
                onSearch={onSearch}
                style={{ width: "100%", float: 'right', marginBottom: 20, marginTop: 20 }}
            />
            <Table 
                style={{ marginTop: 30 }}
                dataSource={ searchInput.length > 1 ? filteredResults : videos } 
                columns={columns}
                rowKey="id"
                loading={loading}
                scroll={{ x: 1000 }}
            />
        </>
    );
}

export default ListaVideos
